//@flow

import React from 'react';
import { DropdownItem } from 'reactstrap';

type Props = {
  location: Object,
  link: string,
  children: Object,
  title: string,
  isElementVisible: boolean,
};

const DropdownElements = ({
  link,
  title,
  location,
  isElementVisible,
}: Props) => {
  // const isActive = location.pathname === link;
  return isElementVisible ? (
    <a href={link}>
      <DropdownItem>{title}</DropdownItem>
    </a>
  ) : null;
};

export default DropdownElements;



// WEBPACK FOOTER //
// ./src/components/TopBar/DropdownElements.jsx